import { render, staticRenderFns } from "./DesktopNavbar.vue?vue&type=template&id=39c83138&"
import script from "./DesktopNavbar.vue?vue&type=script&lang=js&"
export * from "./DesktopNavbar.vue?vue&type=script&lang=js&"
import style0 from "./DesktopNavbar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports